import { Button, Card, CardContent, Grid, GridColumn, Heading, Icon, Notice, Select, Separator, Spinner, TSelectSimpleValue, Text } from 'telia-front-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import LogoutButton from '../mandate/LogoutButton';
import { EMPTY_VALUE } from '../stores/DealerPreferencesStore';
import useStores from '../stores/UseStores';
import WrapWithContainerInFullPage from '../wrapper/WrapWithContainerInFullPage';

const DealerPreferences = observer((): React.JSX.Element => {
  const {
    dealerPreferencesStore,
    dealerRepresentationStore: { dealer },
    translateStore: { translate },
  } = useStores();
  const { isLoading, isLoadError, isSubmitting, isSubmitted, submitError, profile, profiles, group, groups } = dealerPreferencesStore;

  React.useEffect(() => {
    dealerPreferencesStore.init();
  }, []);

  const savePreferences = () => {
    dealerPreferencesStore.updateDealerPreferences();
  };

  if (isLoading) {
    return <Spinner />;
  }

  if (isLoadError) {
    return <Notice type="error" children={translate('dealer.preferences.loadError')} />;
  }

  return (
    <WrapWithContainerInFullPage>
      <Text>
        <Heading className="h4">{translate('dealer.preferences.heading')}</Heading>
        {!!dealer && (
          <Card padding="small">
            <CardContent>
              <Grid noWrap={true} gutter="small" align={['middle-xs']}>
                <GridColumn width={['min']}>
                  <Icon modifiers="#support" size="xs" />
                </GridColumn>
                <GridColumn width={['max']}>
                  <p className="text-bold">{dealer.displayName}</p>
                  <p className="text-tiny">{dealer.department}</p>
                </GridColumn>
              </Grid>
            </CardContent>
          </Card>
        )}
        <Select
          id="employee-profile"
          label={translate('dealer.preferences.profile')}
          simpleValue={true}
          value={profile || EMPTY_VALUE}
          options={profiles}
          onChange={(value: TSelectSimpleValue) => dealerPreferencesStore.setProfile(value as string)}
          disabled={isSubmitting}
        />
        <Select
          id="employee-group"
          label={translate('dealer.preferences.group')}
          value={group || EMPTY_VALUE}
          options={groups}
          onChange={(value: TSelectSimpleValue) => dealerPreferencesStore.setGroup(value as string)}
          disabled={isSubmitting}
          simpleValue={true}
          live={true}
        />
        <Button
          text={translate('dealer.preferences.submit')}
          isLoading={isSubmitting}
          onClick={() => savePreferences()}
          disabled={isSubmitting}
          type="employee"
          block={true}
        />
        {isSubmitted && <Notice type="success" size="small" children={translate('dealer.preferences.submitSuccess')} />}
        {submitError && <Notice type="error" size="small" children={translate('dealer.preferences.submitError')} />}
        <Separator color="invisible" spacing="small" />
        <Text className="text-center">
          <LogoutButton />
        </Text>
      </Text>
    </WrapWithContainerInFullPage>
  );
});

export default DealerPreferences;
